
import { useUser } from '@reverbdotcom/commons/src/user_hooks';
import experiments from '@reverbdotcom/commons/src/experiments';
import { MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_tracker';
import { useViewTracking } from '@reverbdotcom/commons/src/use_tracking';
import { formatExperimentsForEventAttributes } from '@reverbdotcom/commons/src/elog/mparticle';


export const SELL_FORM_QUALIFYING_EVENT = 'SellFormQualifyingEvent';

export function SellFormQualifyingEvent() {
  useViewTracking({
    componentName: SELL_FORM_QUALIFYING_EVENT,
    eventName: MParticleEventName.ComponentView,
    experiments: formatExperimentsForEventAttributes(useUser(), [
      experiments.SELL_FORM_V2,
    ]),
  }, true);

  return null;
}
